import React from 'react';
import { DEFAULT_ROUTE_DETAILS_ICON } from '../../mockData';
import { IIconTitleAsProps } from '../../../../../sp-types/routeDetailsType';
import { routeDetailsIcons } from '../../routeDetailsUtils';

export const RouteDetailsSubTitle: React.FC<IIconTitleAsProps> = ({ title, icon = DEFAULT_ROUTE_DETAILS_ICON }) => {
  return (
    <div className="flex gap-2">
      <img className="h-6 w-6 my-auto" src={routeDetailsIcons[icon] || DEFAULT_ROUTE_DETAILS_ICON} />
      <p>{title}</p>
    </div>
  );
};
